export const CRM_BASE_PATH = '/app/crm'

/**
 * Who sees the CRM menu item: users whose login payload says Capabilities.CanUseCrm is true.
 * PermissionKeys are deliberately NOT checked: "menu.crm.view" shows up there for most roles even when
 * the user has no CRM access. The flag is set at login, so removing someone's access only takes effect
 * in the menu after they sign in again; the API enforces it on every call (403 CRM_NOT_ALLOWED).
 * @param {{ Capabilities?: { CanUseCrm?: boolean } }|null|undefined} user
 */
export const canViewCrm = user => user?.Capabilities?.CanUseCrm === true

/**
 * Only these two actions need an admin; every other CRM action is open to company users.
 * Same rule as the server (CrmAccess.IsAdmin): super admin, IsAdmin, or RoleId 3.
 */
export const canDeleteCrmRecords = user =>
    Boolean(user?.IsSuperAdmin === true || user?.IsAdmin === true || Number(user?.RoleId) === 3)
